import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private showNewDesignSubject = new BehaviorSubject<boolean>(false);
  showNewDesign$ = this.showNewDesignSubject.asObservable();

  setShowNewDesign(show: boolean) {
    this.showNewDesignSubject.next(show);
  }
}
